import { render, staticRenderFns } from "./ShuttleCard.vue?vue&type=template&id=5ed39249&scoped=true&"
import script from "./ShuttleCard.vue?vue&type=script&lang=js&"
export * from "./ShuttleCard.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleCard.vue?vue&type=style&index=0&id=5ed39249&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed39249",
  null
  
)

export default component.exports